import type { SocialNetworkAccount } from '~/apis'
import { Box } from '~/components/Box'
import { Apple, Facebook, Google } from '~/components/Socials'
import AppleIcon from '~/components/svg/icon-apple.svg?svgr'
import FacebookIcon from '~/components/svg/icon-fb.svg?svgr'
import GoogleIcon from '~/components/svg/icon-gg.svg?svgr'
import { useAuthContext } from '~/hooks/useAuthContext'

import { SocialAccount, type TSocialAccount } from './SocialAccount'

export const ConnectedAccounts: React.FC = () => {
  const { user } = useAuthContext()
  const supportedSocialAccounts: TSocialAccount[] = [
    {
      name: 'Gmail',
      Icon: GoogleIcon,
      profile: user?.socialAccounts?.filter(
        (account): account is SocialNetworkAccount =>
          account.authType === 'google',
      )[0],
      altName: 'Gmail',
      Component: Google,
    },
    {
      name: 'Facebook',
      Icon: FacebookIcon,
      profile: user?.socialAccounts?.filter(
        (account): account is SocialNetworkAccount =>
          account.authType === 'facebook',
      )[0],
      Component: Facebook,
    },
    {
      name: 'Apple',
      Icon: AppleIcon,
      profile: user?.socialAccounts?.filter(
        (account): account is SocialNetworkAccount =>
          account.authType === 'apple',
      )[0],
      Component: Apple,
    },
  ]
  return (
    <Box className="flex flex-col md:flex-row md:justify-between gap-24 p-24">
      <div className="w-full md:w-1/2">
        <div className="text-h6 mb-4">Link with social accounts</div>
        <div className="text-body-s text-text-color-subdued">
          You can link your social accounts (Facebook, Google, Apple), and use
          them for signing in to your Waypoint account
        </div>
      </div>
      <div className="flex flex-col gap-12 w-full md:w-1/2">
        {supportedSocialAccounts.map(social => (
          <SocialAccount key={social.name} {...social} />
        ))}
      </div>
    </Box>
  )
}
